<script>
    import { building } from '$app/environment';
    import { site_origin } from '$lib/stores/globals';
    import { img_cdn } from '$lib/utils/image';

    export let title;
    export let description;
    export let author;
    export let date_published;
    export let date_modified;
    export let image;
    export let path;

    let schema_json = '';


    let published_date = null;
    let modified_date = null;
    try {
        published_date = new Date(date_published).toDateString();

        modified_date = date_modified
            ? new Date(date_modified).toISOString()
            : published_date;

    } catch (e) {
        // console.error(e);
        if (building) {
            throw new Error(
                `Invalid date "${date_published}" or "${date_modified}" in ArticleSchema for "${path}"`
            );
        }
    }

    const schema_data = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: title,
        description: description,
        author: {
            '@type': 'Person',
            name: author
        },
        datePublished: published_date,
        dateModified: modified_date,
        publisher: {
            '@type': 'Organization',
            name: 'Critikid',
            logo: {
                '@type': 'ImageObject',
                url: img_cdn('logo-google-app.png')
            }
        },
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `${site_origin}${path}`
        }
    };

    if (image)
        schema_data.image = {
            '@type': 'ImageObject',
            url: img_cdn(image)
        };

    schema_json = JSON.stringify(schema_data);
</script>

<svelte:head>
    {#if schema_json}
        {@html `<script type="application/ld+json">${schema_json}</script>`}
    {/if}
</svelte:head>
